import { FC } from 'react';
import styled from 'styled-components';
import { PreviewControlBar } from './Controls/PreviewControlBar';

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const PreviewContentContainer: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <ContentContainer>
      <PreviewControlBar />
      {children}
    </ContentContainer>
  );
};
